import React from 'react';
import PlaceholderPage from '../../components/Common/PlaceholderPage';

const BookingPage = () => {
  return (
    <PlaceholderPage 
      title="Book Experience" 
      description="Reserve your farm experience" 
      backLink="/bookings"
    />
  );
};

export default BookingPage;